<template>
    <div class="newsHeaders" :style="`background-image:url('${baseUrl}img/${img}.jpg')`">
        <div class="newsHeaderText">
            <div class="brandAndDate">
                <div class="newsBrand">{{newsBrand}}</div>
                <div class="date">{{date}}</div>                
            </div>
            <div class="headerTitle">{{title}}</div>
            <div class="read" v-show="url.length>0">
                <div @click="openWin()">{{$t('查看原文')}}</div>
                <img src="../../public/img/whiteRight.png" alt="" srcset="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:[
        'img','title','newsBrand','date','url'
    ],
    methods:{
        openWin(){
            window.open(this.url,"blank");
        }
    }
}
</script>
<style lang="less">
.newsHeaders{
    width: 100%;
    position: relative;
    height: 450px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .newsHeaderText{
        position: absolute;
        left: 50%;
        bottom: 10%;
        transform: translate(-50%,0);
        color: #fff;
        // font-size: 2rem;
        // font-weight: bold;
        // letter-spacing: 0.15rem;
        width: 60%;
        height: 50%;
        .brandAndDate{
            display: flex;
            align-items: center;
            .newsBrand{
                font-size: 0.8rem;
                padding: 5px 0.8rem;
                border-radius: 2rem;
                background-color: #fff;
                color: #017CA8;
            }
            .date{
                font-size: 0.8rem;
                margin-left: 0.8rem;
            }
        }
        .headerTitle{
            font-size: 1.8rem;
            margin-top: 0.5rem;
        }
        .read{
            position: absolute;
            right: 0;
            bottom: 0;
            background-color: #22A3C6;
            padding: 5px 1.2rem;

            cursor: pointer;
            display: flex;
            font-size: 0.8rem;
            border-radius: 5rem;
            align-items: center;
            img{
                height: 15px;
                margin-left: 5px;
            }
            div{
                white-space:nowrap;
            }
        }

    }
}
</style>
<i18n>
{
    "en": {
        "查看原文":"View Original"
    },
    "zh":{
        "查看原文":"查看原文"
    }
}
</i18n>
